(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/settings-selector/settings-selector-container.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/settings-selector/settings-selector-container.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;

const _React = React,
  useMemo = _React.useMemo,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const ReactButton = svs.ui.ReactButton;
const RadioButton = svs.ui.reactForm.RadioButton;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const CouponSettingsSelector = svs.components.tipsen.couponSettingsSelector.CouponSettingsSelector;
const _svs$components$tipse = svs.components.tipsen.tipsinfo,
  useFilteredTipsinfoOptions = _svs$components$tipse.useFilteredTipsinfoOptions,
  useFilteredOutcomeInfoChoises = _svs$components$tipse.useFilteredOutcomeInfoChoises;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.engineSelectors,
  selectModuleName = _svs$components$tipse2.selectModuleName,
  selectTipsinfoSupport = _svs$components$tipse2.selectTipsinfoSupport;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const _svs$components$tipse3 = svs.components.tipsen.store.actions.couponSettingsActions,
  setOutcomeInfoChoises = _svs$components$tipse3.setOutcomeInfoChoises,
  setShowCompressedCoupon = _svs$components$tipse3.setShowCompressedCoupon,
  setShowMatchAnalysesInCoupon = _svs$components$tipse3.setShowMatchAnalysesInCoupon,
  setShowVideoAnalysesInCoupon = _svs$components$tipse3.setShowVideoAnalysesInCoupon,
  setTipsinfo = _svs$components$tipse3.setTipsinfo;
const _svs$components$tipse4 = svs.components.tipsen.selectors,
  selectShowCompressedCoupon = _svs$components$tipse4.selectShowCompressedCoupon,
  selectShowMatchAnalysesInCoupon = _svs$components$tipse4.selectShowMatchAnalysesInCoupon,
  selectShowVideoAnalysesInCoupon = _svs$components$tipse4.selectShowVideoAnalysesInCoupon;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const TipsinfoTypes = svs.components.tipsen.engine.constants.TipsinfoTypes;
const SYSTEM_REDUCERA_FRITT = svs.components.tipsen.engine.constants.systems.SYSTEM_REDUCERA_FRITT;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const selectSystemType = svs.components.tipsen.engine.selectors.couponSelectors.selectSystemType;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const isVideoAnalysesFeatureEnabled = !isSelfService && svs.core.detect.feature('ft-pool-betting-video-analyses');
const SettingsSelectorContainer = () => {
  const dispatch = useDispatch();
  const tipsinfoOptions = useFilteredTipsinfoOptions();
  const moduleName = useSelector(selectModuleName);
  const toggleAllSelectedState = useMemo(() => tipsinfoOptions.filter(option => option.isSelected).length === tipsinfoOptions.length, [tipsinfoOptions]);
  const outcomeInfoChoises = useFilteredOutcomeInfoChoises();
  const selectedOutcomeChoise = outcomeInfoChoises ? outcomeInfoChoises.find(el => el.isSelected) : {
    key: 'outcomeLabel'
  };
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;
  const showVideoAnalysesInCoupon = useSelector(selectShowVideoAnalysesInCoupon);
  const showMatchAnalysesInCoupon = useSelector(selectShowMatchAnalysesInCoupon);
  const showCompressedCoupon = useSelector(selectShowCompressedCoupon);
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const couponId = useCouponId();
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType;
  const supportedTipsInfo = useSelector(state => selectTipsinfoSupport(state, pageType));
  const shouldShowLableInCoupon = systemType !== SYSTEM_REDUCERA_FRITT && supportedTipsInfo.outcomeLabel;
  const shouldShowVideoAnalyses = isVideoAnalysesFeatureEnabled && supportedTipsInfo.videoAnalyses;
  const onTipsinfoChange = (field, state) => {
    dispatch(setTipsinfo({
      moduleName,
      changes: [{
        field,
        state
      }]
    }));
  };
  const onToggleAllTipsinfo = () => {
    dispatch(setTipsinfo({
      moduleName,
      changes: tipsinfoOptions.map(_ref => {
        let key = _ref.key;
        return {
          field: key,
          state: !toggleAllSelectedState
        };
      })
    }));
  };
  const onToggleBetButtonDisplay = e => {
    var _e$currentTarget$valu, _e$currentTarget;
    const value = (_e$currentTarget$valu = (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.value) !== null && _e$currentTarget$valu !== void 0 ? _e$currentTarget$valu : e;
    dispatch(setOutcomeInfoChoises({
      moduleName,
      changes: [{
        field: 'display',
        state: value
      }]
    }));
  };
  const onVideoAnalysesChange = show => {
    dispatch(setShowVideoAnalysesInCoupon({
      moduleName,
      changes: [{
        field: 'show',
        state: show
      }]
    }));
  };
  const onMatchAnalysesChange = showMatchAnalyseInCouponOptions => {
    dispatch(setShowMatchAnalysesInCoupon({
      moduleName,
      showMatchAnalyseInCouponOptions
    }));
  };
  const handleHideAll = () => {
    const showMatchAnalyseInCouponOptions = {
      showAll: false,
      showAnalyseForecast: false,
      hideAll: true
    };
    onMatchAnalysesChange(showMatchAnalyseInCouponOptions);
  };
  const handleShowAll = () => {
    const showMatchAnalyseInCouponOptions = {
      showAll: true,
      showAnalyseForecast: false,
      hideAll: false
    };
    onMatchAnalysesChange(showMatchAnalyseInCouponOptions);
  };
  const handleShowAnalyseForecast = () => {
    const showMatchAnalyseInCouponOptions = {
      showAll: false,
      showAnalyseForecast: true,
      hideAll: false
    };
    onMatchAnalysesChange(showMatchAnalyseInCouponOptions);
  };
  const onCompressedCouponChange = show => {
    dispatch(setShowCompressedCoupon({
      moduleName,
      show
    }));
  };
  return React.createElement(React.Fragment, null, isExtraSmall && supportedTipsInfo.compressed && React.createElement(CouponSettingsSelector, null, React.createElement(CouponSettingsSelector.CouponSettingsHeading, null, "Kupong"), React.createElement(CouponSettingsSelector.CouponSettingsButtons, null, React.createElement(RadioButton, {
    checked: !showCompressedCoupon,
    key: "compressed-coupon-show-radio-group",
    name: "compressed-coupon-show-hide-radio-group",
    onChange: () => onCompressedCouponChange(false),
    value: "hide"
  }, "Standard"), !isGoalCount && React.createElement(RadioButton, {
    checked: showCompressedCoupon,
    key: "compressed-coupon-hide-radio-group",
    name: "compressed-coupon-show-hide-radio-group",
    onChange: () => onCompressedCouponChange(true),
    value: "show"
  }, "Kompakt"))), React.createElement("div", {
    className: "group-fieldsets".concat(isExtraSmall ? '--small-screen' : '--big-screen')
  }, shouldShowLableInCoupon && React.createElement(CouponSettingsSelector, null, React.createElement(CouponSettingsSelector.CouponSettingsHeading, null, "Tecken i knapp"), React.createElement(CouponSettingsSelector.CouponSettingsButtons, null, outcomeInfoChoises.map(_ref2 => {
    let isSelected = _ref2.isSelected,
      title = _ref2.title,
      key = _ref2.key;
    const disabled = showCompressedCoupon && isExtraSmall && key === TipsinfoTypes.SvenskaFolket;
    return React.createElement(RadioButton, {
      checked: isSelected,
      disabled: disabled,
      key: key,
      onChange: onToggleBetButtonDisplay,
      value: key
    }, title);
  }))), shouldShowVideoAnalyses && React.createElement(CouponSettingsSelector, null, React.createElement(CouponSettingsSelector.CouponSettingsHeading, null, "Videoanalyser"), React.createElement(CouponSettingsSelector.CouponSettingsButtons, null, React.createElement(RadioButton, {
    checked: showVideoAnalysesInCoupon,
    key: "tipset-video-analyses-show-radio-group",
    name: "tipset-video-analyses-show-hide-radio-group",
    onChange: () => onVideoAnalysesChange(true),
    value: "show"
  }, "Visa"), React.createElement(RadioButton, {
    checked: !showVideoAnalysesInCoupon,
    key: "tipset-video-analyses-hide-radio-group",
    name: "tipset-video-analyses-show-hide-radio-group",
    onChange: () => onVideoAnalysesChange(false),
    value: "hide"
  }, "D\xF6lj")))), supportedTipsInfo.analys && React.createElement(CouponSettingsSelector, null, React.createElement(CouponSettingsSelector.CouponSettingsHeading, null, "Spelanalyser"), React.createElement(CouponSettingsSelector.CouponSettingsButtons, null, React.createElement(RadioButton, {
    checked: showMatchAnalysesInCoupon.showAll,
    key: "tipset-match-analyses-show-radio-group",
    name: "tipset-match-analyses-show-hide-radio-group",
    onChange: () => handleShowAll(),
    value: "show"
  }, "Full analys"), React.createElement(RadioButton, {
    checked: showMatchAnalysesInCoupon.showAnalyseForecast,
    key: "tipset-match-analyses-prognos-radio-group",
    name: "tipset-match-analyses-show-hide-radio-group",
    onChange: () => handleShowAnalyseForecast(),
    value: "forecast"
  }, "Speltips"), React.createElement(RadioButton, {
    checked: showMatchAnalysesInCoupon.hideAll,
    key: "tipset-match-analyses-hide-radio-group",
    name: "tipset-match-analyses-show-hide-radio-group",
    onChange: () => handleHideAll(),
    value: "hide"
  }, "D\xF6lj"))), React.createElement(CouponSettingsSelector, null, React.createElement(CouponSettingsSelector.CouponSettingsHeading, null, "Information i kupong"), React.createElement("div", {
    className: "pg_coupon_settings__tipsinfo_wrapper"
  }, (tipsinfoOptions === null || tipsinfoOptions === void 0 ? void 0 : tipsinfoOptions.length) > 1 && React.createElement(ReactButton, {
    className: "tipset-tips-info-btn",
    inverted: toggleAllSelectedState,
    onClick: onToggleAllTipsinfo,
    tabIndex: "0",
    thin: true,
    transparent: !toggleAllSelectedState
  }, "All info"), tipsinfoOptions === null || tipsinfoOptions === void 0 ? void 0 : tipsinfoOptions.map(_ref3 => {
    let isSelected = _ref3.isSelected,
      title = _ref3.title,
      key = _ref3.key;
    return React.createElement(ReactButton, {
      "aria-checked": isSelected,
      className: "tipset-tips-info-btn",
      "data-testid": "test-id-".concat(key),
      disabled: systemType !== SYSTEM_REDUCERA_FRITT && key === selectedOutcomeChoise.key,
      inverted: isSelected,
      key: key,
      onClick: () => {
        onTipsinfoChange(key, !isSelected);
      },
      role: "checkbox",
      thin: true,
      transparent: !isSelected
    }, "+", ' ', title);
  }))));
};
setGlobal('svs.components.tipsen.routePlaySpela.SettingsSelectorContainer', SettingsSelectorContainer);

 })(window);